<template>
    <div
        class="px-4 py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150 flex gap-4"
    >
        <div class="flex-shrink-0 p-3 flex flex-col gap-2">
            <span class="flex-shrink-0 text-xs font-medium text-teal-700 p-3 rounded-full"
                >{{ notification.status }} ({{ notification.type }})</span
            >

            <button
                v-if="notification.status !== 'read'"
                @click="markRead"
                class="border flex justify-center items-center border-gray-400 hover:border-gray-800 text-xs rounded px-2 py-1"
            >
                Mark as read
            </button>
            <button
                v-if="notification.status !== 'unread'"
                @click="markUnread"
                class="border flex justify-center items-center border-gray-400 hover:border-gray-800 text-xs rounded px-2 py-1"
            >
                Mark as unread
            </button>
            <button
                @click="deleteNot"
                class="border flex justify-center items-center border-gray-400 hover:border-gray-800 text-xs rounded px-2 py-1"
            >
                Delete
            </button>
        </div>
        <pre class="flex-1 w-full max-w-2xl p-2" style="min-height:130px;">{{
            notification.data
        }}</pre>
    </div>
</template>

<script>
import api from '../lib/api'
export default {
    props: ['notification', 'user'],
    methods: {
        async deleteNot() {
            if (!window.confirm('Delete?')) {
                return
            }
            await api.deleteNotificationForUser(this.user.id, this.notification.id)
            window.location.reload()
        },
        async markRead() {
            await api.changeNotificationStatusForUser(this.user.id, this.notification.id, 'read')
            window.location.reload()
        },
        async markUnread() {
            await api.changeNotificationStatusForUser(this.user.id, this.notification.id, 'unread')
            window.location.reload()
        },
    },
}
</script>
